import React, { useState } from "react";
import { MoreHorizontal, Phone, X } from "lucide-react";
import { sfx } from "./SoundEngine";

export default function MobileNavV2({
  tabs = [],
  activeId,
  onChange,
  fabIcon: FabIcon = Phone,
  onFab,
}) {
  const [moreOpen, setMoreOpen] = useState(false);
  const visibleTabs = tabs.slice(0, 3);
  const moreTabs = tabs.slice(3);
  const moreIsActive = moreTabs.some((tab) => tab.id === activeId);

  function choose(id) {
    sfx.tap();
    setMoreOpen(false);
    onChange?.(id);
  }

  return (
    <>
      <nav className="arena-bottombar" aria-label="Primary">
        <div className="arena-mobile-nav-cluster">
          {visibleTabs.slice(0, 2).map((tab) => (
            <Tab key={tab.id} tab={tab} active={tab.id === activeId} onChoose={choose} />
          ))}
        </div>

        <button
          type="button"
          onClick={() => { sfx.tap(); onFab?.(); }}
          className="arena-fab-center"
          aria-label="Talk to AEON"
        >
          <FabIcon className="h-5 w-5" />
        </button>

        <div className="arena-mobile-nav-cluster">
          {visibleTabs.slice(2).map((tab) => (
            <Tab key={tab.id} tab={tab} active={tab.id === activeId} onChoose={choose} />
          ))}
          <button
            type="button"
            className={`arena-tab ${moreIsActive || moreOpen ? "is-active" : ""}`}
            onClick={() => { sfx.tap(); setMoreOpen((open) => !open); }}
            aria-expanded={moreOpen}
            aria-controls="arena-more-menu"
          >
            <MoreHorizontal className="h-5 w-5" />
            <span>More</span>
          </button>
        </div>
      </nav>

      {moreOpen ? (
        <div className="arena-more-backdrop" role="presentation" onClick={() => setMoreOpen(false)}>
          <section
            id="arena-more-menu"
            className="arena-more-sheet"
            role="dialog"
            aria-modal="true"
            aria-label="More AEON sections"
            onClick={(event) => event.stopPropagation()}
          >
            <header>
              <div>
                <span>AEON / Sections</span>
                <strong>More from the desk</strong>
              </div>
              <button type="button" onClick={() => setMoreOpen(false)} aria-label="Close menu">
                <X className="h-4 w-4" />
              </button>
            </header>
            <div className="arena-more-grid">
              {moreTabs.map((tab, index) => {
                const Icon = tab.icon;
                const active = tab.id === activeId;
                return (
                  <button
                    key={tab.id}
                    type="button"
                    className={active ? "is-active" : ""}
                    onClick={() => choose(tab.id)}
                    aria-current={active ? "page" : undefined}
                  >
                    <span>{String(index + 4).padStart(2, "0")}</span>
                    {Icon ? <Icon className="h-4 w-4" /> : null}
                    <strong>{tab.label}</strong>
                  </button>
                );
              })}
            </div>
          </section>
        </div>
      ) : null}
    </>
  );
}

function Tab({ tab, active, onChoose }) {
  const Icon = tab.icon;
  return (
    <button
      type="button"
      className={`arena-tab ${active ? "is-active" : ""}`}
      onClick={() => onChoose(tab.id)}
      aria-label={tab.label}
      aria-current={active ? "page" : undefined}
    >
      {Icon ? <Icon className="h-5 w-5" /> : null}
      <span>{tab.label}</span>
    </button>
  );
}
